import {api} from './api';
import { Currencies } from '../types';

export interface ShippingRegion {
	code: string;
	name: string;
	region: string;
	currency: Currencies;
}

export interface CompanyShippingRegion {
	countryCode: string;
	name: string;
	region: string;
	shippingMethodId: number;
}

export interface BulkUpdateShippingRegionsPayload {
	addCountries: string[];
	removeCountries: string[];
	shippingMethodId: number;
}

export const shippingRegionsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getAllShippingRegions: builder.query<ShippingRegion[], void>({
			query: () => ({
				url: 'companyShippingRegions/countries',
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 }
		}),
		getCompanyShippingRegions: builder.query<CompanyShippingRegion[], void>({
			query: () => ({
				url: 'companyShippingRegions',
				method: 'GET',
			}),
			extraOptions: { maxRetries: 1 }
		}),
		bulkUpdateCompanyShippingRegions: builder.mutation<void, BulkUpdateShippingRegionsPayload>({
			query: (payload) => ({
				url: 'companyShippingRegions/updateBulk',
				method: 'PUT',
				body: payload,
			}),
		}),
	})
});

export const { 
	useGetAllShippingRegionsQuery, 
	useGetCompanyShippingRegionsQuery,
	useBulkUpdateCompanyShippingRegionsMutation
} = shippingRegionsApi;
